import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';

import { ViewContent } from '@/components/view-layout';
import { useIngredient } from '@/features/ingredients/api/ingredients-queries';
import { IngredientCostForm } from '@/features/ingredients/components/ingredient-cost-form';
import { IngredientDetailsForm } from '@/features/ingredients/components/ingredient-details-form';
import { IngredientEditHeader } from '@/features/ingredients/components/ingredient-edit-header';
import { IngredientEditSectionTitle } from '@/features/ingredients/components/ingredient-edit-section-title';
import { IngredientEditTabs } from '@/features/ingredients/components/ingredient-edit-tabs';
import { useManagedSuppliers } from '@/features/suppliers/api/supplier-queries';

function IngredientEditContent({ ingredientId }: { ingredientId: string }) {
  const { data: ingredient } = useIngredient(ingredientId, null);
  const { data: suppliers } = useManagedSuppliers();

  if (!ingredient) {
    // TODO: Handle loading state or error state
    return <div>Error: Ingredient not found</div>;
  }

  return (
    <>
      <IngredientEditHeader ingredient={ingredient} isEditable />
      <ViewContent>
        <div className="flex h-full pt-6">
          <div className="flex flex-col flex-1 px-6">
            <div>
              <IngredientEditSectionTitle>Details</IngredientEditSectionTitle>
              <IngredientDetailsForm
                ingredient={ingredient}
                suppliers={suppliers}
                isEditable={true}
              />
            </div>
            <div className="mt-6">
              <IngredientEditSectionTitle>Cost</IngredientEditSectionTitle>
              <IngredientCostForm
                ingredient={ingredient}
                organisationId={null}
                isPriceEditable={false}
                isQuantityEditable={true}
                currencyCode={'EUR'}
                measurementSystem={'metric'}
              />
            </div>
            <div className="mt-6">
              <IngredientEditSectionTitle>Recipes</IngredientEditSectionTitle>
            </div>
          </div>
          <div className="flex flex-col flex-1">
            <IngredientEditTabs ingredient={ingredient} isEditable={true} />
          </div>
        </div>
      </ViewContent>
    </>
  );
}

export function AdminIngredientEditPage() {
  const { ingredientId } = Route.useParams();

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <IngredientEditContent ingredientId={ingredientId} />
    </Suspense>
  );
}

export const Route = createFileRoute(
  '/_authenticated/admin/suppliers/$supplierId/$ingredientId',
)({
  component: AdminIngredientEditPage,
});
